import React from 'react';
import { useIntl } from 'react-intl';

import { getLogoUrl } from '../helpers/App';

const LoadingMain = () => {
  const intl = useIntl();

  return (
    <div className="loading-main-wrapper">
      <div className="loading-logo">
        <img src={getLogoUrl()} alt="" />
      </div>
      <div className="loader-wrapper">
        <div className="loader">
          {intl.formatMessage({
            defaultMessage: 'Loading...',
          })}
        </div>
      </div>
    </div>
  );
};

export default LoadingMain;
